import React from 'react';
import { Card, CardContent } from '../ui/card';
import { cn } from '../../lib/utils';

/**
 * Reusable Stats Card Component
 * Used across DSR, Vendor, Breach, and other dashboards
 */
export function StatsCard({ 
  title, 
  value, 
  icon: Icon, 
  borderColor = 'border-l-blue-500',
  iconBgColor = 'bg-blue-100 dark:bg-blue-950',
  iconColor = 'text-blue-600 dark:text-blue-400',
  valueColor = '',
  className 
}) {
  return (
    <Card className={cn('border-l-4', borderColor, className)}>
      <CardContent className="p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-muted-foreground">{title}</p>
            <p className={cn('text-2xl font-bold', valueColor)}>{value}</p>
          </div>
          {Icon && (
            <div className={cn('h-10 w-10 rounded-full flex items-center justify-center', iconBgColor)}>
              <Icon className={cn('h-5 w-5', iconColor)} />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}

// Pre-configured variants for common use cases
export function OpenStatsCard({ value, icon }) {
  return (
    <StatsCard
      title="Open"
      value={value}
      icon={icon}
      borderColor="border-l-blue-500"
      iconBgColor="bg-blue-100 dark:bg-blue-950"
      iconColor="text-blue-600 dark:text-blue-400"
    />
  );
}

export function OverdueStatsCard({ value, icon }) {
  return (
    <StatsCard
      title="Overdue"
      value={value}
      icon={icon}
      borderColor="border-l-red-500"
      iconBgColor="bg-red-100 dark:bg-red-950"
      iconColor="text-red-600 dark:text-red-400"
      valueColor="text-red-600 dark:text-red-400"
    />
  );
}

export function DueSoonStatsCard({ value, icon, days = 7 }) {
  return (
    <StatsCard
      title={`Due Soon (${days}d)`}
      value={value}
      icon={icon}
      borderColor="border-l-amber-500"
      iconBgColor="bg-amber-100 dark:bg-amber-950"
      iconColor="text-amber-600 dark:text-amber-400"
      valueColor="text-amber-600 dark:text-amber-400"
    />
  );
}

export function ClosedStatsCard({ value, icon }) {
  return (
    <StatsCard
      title="Closed"
      value={value}
      icon={icon}
      borderColor="border-l-green-500"
      iconBgColor="bg-green-100 dark:bg-green-950"
      iconColor="text-green-600 dark:text-green-400"
      valueColor="text-green-600 dark:text-green-400"
    />
  );
}

export function HighRiskStatsCard({ value, icon }) {
  return (
    <StatsCard
      title="High Risk"
      value={value}
      icon={icon}
      borderColor="border-l-red-500"
      iconBgColor="bg-red-100 dark:bg-red-950"
      iconColor="text-red-600 dark:text-red-400"
      valueColor="text-red-600 dark:text-red-400"
    />
  );
}

export function ActiveStatsCard({ value, icon }) {
  return (
    <StatsCard
      title="Active"
      value={value}
      icon={icon}
      borderColor="border-l-green-500"
      iconBgColor="bg-green-100 dark:bg-green-950"
      iconColor="text-green-600 dark:text-green-400"
      valueColor="text-green-600 dark:text-green-400"
    />
  );
}

export default StatsCard;
